export default "__VITE_ASSET__Jg_fgajI__"